import { Fragment } from 'react';

import Skeleton from '../../../../Skeleton/Skeleton';

import BreadcrumbIndicator from './Indicator';

const BreadcrumbSkeleton = ({ stepsLength, indicator }) => {
  const skeletonCount = stepsLength < 2 ? 3 : stepsLength;

  return (
    <div
      aria-hidden="true"
      className="flex w-full items-center gap-2 overflow-x-auto overflow-y-hidden">
      {Array.from({ length: skeletonCount }, (_, index) => (
        <Fragment key={index}>
          <Skeleton
            height="20px"
            width={`${[80, 60, 90, 70, 85][index % 5]}px`}
            baseColor="#EEEEEE"
            highlight="#FAFAFA"
            className="rounded text-sm"
          />
          {index !== skeletonCount - 1 && <BreadcrumbIndicator icon={indicator} />}
        </Fragment>
      ))}
    </div>
  );
};

export default BreadcrumbSkeleton;
